import { RefreshToken } from "@/providers/AuthenticationProvider/AuthenticationProvider.decl";
import { noop } from "@aircall/tractor";
import {
  FetchResult,
  Observable,
  ServerError,
  fromPromise,
} from "@apollo/client";
import { ErrorLink, ErrorResponse } from "@apollo/client/link/error";

/**
 * Handle error if api request fails
 */
export const onRequestError =
  (logoutHandler: VoidFunction, refreshToken: RefreshToken) =>
  ({
    networkError,
    operation,
    forward,
  }: ErrorResponse): Observable<FetchResult> | void => {
    const has401Error =
      networkError && (networkError as ServerError).statusCode === 401;
    const hasUnauthorizedException =
      networkError &&
      JSON.stringify(networkError).includes("UnauthorizedException");

    if (has401Error || hasUnauthorizedException) {
      return fromPromise(
        refreshToken()
          .then(() => {
            return true;
          })
          .catch(() => {
            // Clear all stored tokens, which will force user to logout
            logoutHandler();
          })
      )
        .filter((value) => Boolean(value))
        .flatMap(() =>
          // when refreshing token succeeds, retry the request, return the new observable
          forward(operation)
        );
    }
    return noop();
  };

export const errorLink = (
  logoutHandler: VoidFunction,
  refreshTokenHandler: RefreshToken
): ErrorLink =>
  new ErrorLink(onRequestError(logoutHandler, refreshTokenHandler));
